// Turbo disables the submitter of the forms it submits. This does the same for the forms Turbo
// leaves to the browser and for links with `data-disable-with`, and swaps in that label.

const disabledElements = new Set()
const originalLabels = new Map()

document.addEventListener("click", (event) => {
  const link = event.target.closest?.("a[data-disable-with]")

  if (disabledElements.has(link)) {
    event.preventDefault()
    event.stopImmediatePropagation()
  } else if (link && isPlainClick(event)) {
    disableDuringNavigation(event, [link], link)
  }
}, true)

document.addEventListener("submit", (event) => {
  const submitButtons = [...event.target.elements].filter((element) => element.type === "submit" && !element.disabled)

  disableDuringNavigation(event, submitButtons, event.submitter)
}, true)

window.addEventListener("pageshow", ({ persisted }) => {
  if (persisted) {
    disabledElements.forEach(enable)
    disabledElements.clear()
    originalLabels.forEach((label, element) => setLabel(element, label))
    originalLabels.clear()
  }
})

function isPlainClick(event) {
  return event.button === 0 && !(event.altKey || event.ctrlKey || event.metaKey || event.shiftKey)
}

// Disables once the browser has built the form data, which leaves out a disabled submitter.
function disableDuringNavigation(event, elements, submitter) {
  setTimeout(() => {
    if (event.defaultPrevented) return

    elements.forEach(disable)

    if (submitter?.dataset.disableWith) {
      originalLabels.set(submitter, getLabel(submitter))
      setLabel(submitter, submitter.dataset.disableWith)
    }
  })
}

function disable(element) {
  disabledElements.add(element)

  if (element instanceof HTMLAnchorElement) {
    element.setAttribute("aria-disabled", "true")
  } else {
    element.disabled = true
  }
}

function enable(element) {
  if (element instanceof HTMLAnchorElement) {
    element.removeAttribute("aria-disabled")
  } else {
    element.disabled = false
  }
}

function getLabel(element) {
  return element instanceof HTMLInputElement ? element.value : [...element.childNodes]
}

function setLabel(element, label) {
  if (element instanceof HTMLInputElement) {
    element.value = label
  } else {
    element.replaceChildren(...[label].flat())
  }
}
